import styled, { css } from 'styled-components';
var SpacerElement = styled.div.withConfig({
  displayName: "style__SpacerElement",
  componentId: "sc-1f59fk4-0"
})(["", ";", ";", ";display:", ";"], function (_ref) {
  var grow = _ref.grow;
  return grow && 'flex-grow: 1;';
}, function (_ref2) {
  var width = _ref2.width;
  return width && css(["width:", ";"], width);
}, function (_ref3) {
  var height = _ref3.height;
  return height && css(["height:", ";"], height);
}, function (props) {
  return props.display;
});
export default SpacerElement;